<template>
    <div>
        <template v-for="(item, index) of items">
           <v-row no-gutters :key="index">
               <v-col cols="6">
                    <v-text-field dense readonly outlined type="number" color="primary" v-model="item.step" ></v-text-field>
               </v-col>
               <v-col cols="6" class="pl-2">
                    <v-text-field dense outlined type="number" color="primary" @input="userEntry(index, $event)" v-model="item.measuredValue" ></v-text-field>
               </v-col>
           </v-row>
        </template>
    </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      items: []
    }
  },
  methods: {
    userEntry(index, value) {
      this.items[index].measuredValue = value
      this.$emit('input', this.items)
    }
  },
  mounted() {
    this.items = this.value
  },
  watch: {
    value: {
      handler() {
        this.items = this.value
      }
    }
  }
}
</script>
